// extracted by mini-css-extract-plugin
module.exports = {"deepDive__title":"DeepDive_deepDive__title__vX__g"};